"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "reports*"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector",
    d: "M5.27778 2.74767C5.27819 2.28388 5.46277 1.83924 5.79094 1.51151C6.1191 1.18378 6.56399 0.999794 7.02778 1H8.97222C9.43601 0.999794 9.8809 1.18378 10.2091 1.51151C10.5372 1.83924 10.7218 2.28388 10.7222 2.74767V4.12356H13.25C13.7138 4.12335 14.1587 4.30734 14.4868 4.63507C14.815 4.96279 14.9996 5.40743 15 5.87122V14.4174C14.9998 14.572 14.9382 14.7202 14.8289 14.8294C14.7195 14.9386 14.5712 15 14.4167 15H1.58333C1.42862 15 1.28025 14.9385 1.17085 14.8291C1.06146 14.7198 1 14.5714 1 14.4167V8.20222C1.0001 7.97251 1.04545 7.74507 1.13345 7.53288C1.22145 7.3207 1.35038 7.12792 1.51289 6.96556C1.67539 6.80321 1.86828 6.67444 2.08054 6.58663C2.29281 6.49882 2.52029 6.45368 2.75 6.45378H5.27778V2.74767ZM6.44444 13.8357H9.55556V2.74767C9.55535 2.59309 9.4938 2.44492 9.38443 2.33569C9.27505 2.22646 9.1268 2.16511 8.97222 2.16511H7.02778C6.87307 2.16511 6.7247 2.22657 6.6153 2.33597C6.5059 2.44536 6.44444 2.59374 6.44444 2.74844V13.8357ZM5.27778 7.61889H2.75C2.59543 7.61889 2.44717 7.68024 2.3378 7.78947C2.22842 7.8987 2.16687 8.04687 2.16667 8.20144V13.8341H5.27778V7.61889ZM10.7222 13.8333H13.8333V5.872C13.8333 5.71729 13.7719 5.56892 13.6625 5.45952C13.5531 5.35013 13.4047 5.28867 13.25 5.28867H10.7222V13.8357V13.8333Z",
    fill: fill
  })));
};

exports["default"] = _default;